<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
      </div>
      <b-row>
        <b-col lg="8">
          <b-input-group>
            <b-input-group-prepend>
              <label>Filename</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.filename" type="search" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <label class="p-1">Project</label>
            </b-input-group-append>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt" class="mr-1"></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success mr-1" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary mr-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
              <b-button variant="primary mr-1" @click="reload()"><i class="fa fa-refresh"></i> Sync From Server</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size: smaller" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked" show-empty :busy="isBusy"
        :filter="tblData.filename" :filter-included-fields="filterOn" @filtered="onFiltered">
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <template v-slot:cell(action)="data">
          <div>
            <b-button-group size="sm">
              <b-button class="mr-2" variant="success" @click="download(data.item)"><i class="fa fa-download"></i> Download</b-button>
              <b-button variant="info" @click="downloadFormated(data.item)"><i class="fa fa-download"></i> Download Formated</b-button>
              <!-- <b-button variant="info" @click="reprocessconfirm(data.item)"><i class="fa fa-refresh"></i>
                Re-Procesing</b-button> -->
              <!-- <b-button variant="danger" @click="deleteblobconfirm(data.item)"><i class="fa fa-trash"></i>
                Delete</b-button> -->
            </b-button-group>
          </div>
        </template>
        <template v-slot:cell(size)="data">{{
          data.item.size | numFormat("0,0")
        }}</template>
        <template v-slot:cell(createdat)="data">{{
          data.item.createdat | moment("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-slot:cell(downloadBy)="data">
          <span v-if="data.item.downloadBy">
            {{ data.item.downloadBy }} - {{ data.item.downloadAt | moment("YYYY-MM-DD HH:mm") }}
          </span>
        </template>
        <template v-slot:cell(processedBy)="data">
          <span v-if="data.item.processedBy">
            {{ data.item.processedBy }} - {{ data.item.processedAt | moment("YYYY-MM-DD HH:mm") }}
          </span>
        </template>

        <template v-slot:cell(rowRecorded)="data">
          {{ data.item.rowRecordedCheck | numFormat("0,0") }} <b>OF</b> {{ data.item.rowRecorded | numFormat("0,0") }} <i
            :class="(data.item.rowRecorded - data.item.rowRecordedCheck) == 0 ? 'fa fa-check-circle-o text-success' : ''"
            aria-hidden="true"></i>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width: 80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <b-modal v-model="showReprocessConfirm" title="Reprocess Record?" :centered="true" @ok="reprocess">
      <p class="mb-1">
        1 record will be reprocessed, this may take a few minutes
      </p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import fileazure from "../../apis/fileazure";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isLoading: false,
      isBusy: false,
      showDelConfirm: false,
      showReprocessConfirm: false,
      filterOn: [],
      projectsFilt: [{
        value: '', text: '-- ALL --'
      }],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "createdat",
        sortDesc: true,
        tablename: "historyupload",
        customQuery: "",
        pjxkey: '',
        filename: moment().format("YYYYMMDD"),
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "filename",
          label: "File Name",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "min-width:100px",
          sortable: true,
        },

        {
          key: "size",
          label: "Size (Bytes)",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "type",
          label: "Type Transaction",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "container",
          label: "Container",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "createby",
          label: "Created By",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "createdat",
          label: "created On",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "pjxname",
          label: "Project",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "downloadBy",
          label: "Log Download",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "processedBy",
          label: "Log Process",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "rowRecorded",
          label: "Row Checking (BySystem)",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Actions",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: "min-width:100px",
        },
      ];
      return fields;
    },
  },
  async created() {
    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
  },
  watch: {
    filter(val) {
      this.tblData.filename = val;
      this.refresh();
    }
  },
  methods: {

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length
      this.currentPage = 1
    },
    async reload() {
      try {
        if (this.tblData.pjxkey=='') {
          throw new Error('Please select project');
        }
        await fileazure.synchronizefromserver(this.tblData);
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }

    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    async data() {
      try {
        this.isBusy = true;
        // this.tblData.filename=this.filter;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await fileazure.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }

    },
    reprocessconfirm(data) {
      try {
        this.rowClicked(data);
        this.showReprocessConfirm = true;
      } catch (e) {
        console.log(e);
      }
    },
    async reprocess() {
      try {
        this.isLoading = true;
        await fileazure.reprocess(this.model);
        this.refresh()
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async deleteblobconfirm(data) {
      try {
        this.rowClicked(data);
        this.showDelConfirm = true;
      } catch (e) {
        console.log(e);
      }
    },
    async deleteData() {
      try {
        this.isLoading = true;
        const list = this.tblData.items;
        const data = await fileazure.remove(this.model);
        const findIdx = list.findIndex((x) => x.filename == data.filename);
        if (findIdx > -1) {
          list.splice(findIdx, 1);
          this.tblData.total = list.length;
          this.tblData.items = list;
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async download(obj) {
      try {
        this.isLoading = true;
        await fileazure.download(obj);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async downloadFormated(obj) {
      try {
        this.isLoading = true;
        await fileazure.downloadFormated(obj);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "paylater.home" });
    },
    clearFilter() {
      this.tblData.filename = '';
    },
    refresh() {
      this.$refs.table.refresh();
    },
  },
};
</script>